import $ from '@vaersaagod/tools/Dom';
import Dispatch from '@vaersaagod/tools/Dispatch';
import * as Events from '../lib/events';

export default el => {
    const button = $(el);
    const menu = $(button.attr('href'));
    const header = $('[data-page-header]');
    const hamburgerTop = button.find('path:nth-of-type(1)').get(0);
    const hamburgerMiddle = button.find('path:nth-of-type(2)').get(0);
    const hamburgerBottom = button.find('path:nth-of-type(3)').get(0);

    let active = false;

    const hamburgerToX = () => {
        const offset = 8;
        TweenLite.to(hamburgerTop, 0.15, { y: offset, ease: Sine.easeIn });
        TweenLite.to(hamburgerBottom, 0.15, { y: offset * -1,
            ease: Sine.easeIn,
            onComplete: () => {
                TweenLite.set(hamburgerMiddle, { opacity: 0 });
                TweenLite.to(hamburgerTop, 0.2, { rotationZ: '45deg', transformOrigin: '50% 50%', ease: Quart.easeOut });
                TweenLite.to(hamburgerBottom, 0.2, { rotationZ: '-45deg', transformOrigin: '50% 50%', ease: Quart.easeOut });
            } });
    };

    const xToHamburger = () => {
        TweenLite.to(hamburgerTop, 0.1, { rotationZ: '0deg', transformOrigin: '50% 50%', ease: Sine.easeIn });
        TweenLite.to(hamburgerBottom, 0.1, { rotationZ: '0deg',
            transformOrigin: '50% 50%',
            ease: Sine.easeIn,
            onComplete: () => {
                TweenLite.set(hamburgerMiddle, { opacity: 1 });
                TweenLite.to(hamburgerTop, 0.15, { y: 0, ease: Quart.easeOut, clearProps: 'all' });
                TweenLite.to(hamburgerBottom, 0.15, { y: 0, ease: Quart.easeOut, clearProps: 'all' });
            } });
    };

    const keyHandler = e => {
        const key = e.keyCode || e.which;
        if (active && key === 27) {
            Dispatch.emit(Events.MOBILEMENU_CLOSE, header);
        }
    };

    const open = () => {
        if (!active) {
            active = true;
            document.addEventListener('keyup', keyHandler);
            button.attr('aria-expanded', true).attr('aria-label', button.data('close'));
            menu.attr('hidden', null);
            hamburgerToX();
        }
    };

    const close = () => {
        if (active) {
            active = false;
            document.removeEventListener('keyup', keyHandler);
            button.attr('aria-expanded', false).attr('aria-label', button.data('label'));
            menu.attr('hidden', '');
            xToHamburger();
        }
    };

    const toggle = e => {
        e.preventDefault();
        Dispatch.emit(button.attr('aria-expanded') === 'false' ? Events.MOBILEMENU_OPEN : Events.MOBILEMENU_CLOSE, header);
    };

    const init = () => {
        button.data('label', button.attr('aria-label'));
        button.on('click', toggle);
        Dispatch.on(Events.MOBILEMENU_OPEN, open);
        Dispatch.on(Events.MOBILEMENU_CLOSE, close);
    };

    const destroy = () => {
        button.off('click', toggle);
        Dispatch.off(Events.MOBILEMENU_OPEN, open);
        Dispatch.off(Events.MOBILEMENU_CLOSE, close);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/MenuToggle.js